import Keycloak, { KeycloakConfig } from 'keycloak-js';
import { makeAutoObservable } from 'mobx';
import { IUser } from '../../CommonInterface';

interface CustomKeycloakConfig extends KeycloakConfig {
    INACTIVITY_TIMEOUT: number;
}

class AuthStore {
    private _user: IUser | undefined = undefined;

    private pendingAutorisationServer: boolean = true;

    private _keyClock: Keycloak = new Keycloak('');

    private _InactivityTimout: number | undefined = undefined;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    async checkAuth() {
        return new Promise((resolve, reject) => {
            let GetJsonOption = (): KeycloakConfig => {
                this.pendingAutorisationServer = true;
                let Rez: CustomKeycloakConfig = {
                    url: '',
                    realm: '',
                    clientId: '',
                    INACTIVITY_TIMEOUT: 0
                };
                let xhr = new XMLHttpRequest();
                xhr.open('GET', '/ixyber/vision/auth/fesetting', false);

                xhr.onerror = function (e) {
                    console.error(xhr.statusText);
                };
                xhr.send(null);

                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        Rez = JSON.parse(xhr.responseText);
                    } else {
                        console.error(xhr.statusText);
                    }
                }

                this.InactivityTimout = Rez.INACTIVITY_TIMEOUT;

                return Rez;
            };

            this._keyClock = new Keycloak(GetJsonOption());

            this._keyClock.onAuthSuccess = () => {
                this.setUser();
            };

            this._keyClock.onAuthError = () => {
                this._user = undefined;
            };

            this._keyClock.onAuthRefreshError = () => {
                this._user = undefined;
            };

            this._keyClock.onAuthRefreshSuccess = () => {
                this.setUser();
            };

            this._keyClock.onAuthLogout = () => {
                this._user = undefined;
            };

            this._keyClock.onTokenExpired = () => {
                console.log('onToken');
                this._keyClock
                    ?.updateToken(5)
                    .then((refreshed: boolean) => {
                        if (refreshed) {
                            console.debug('Token was successfully refreshed');
                        } else {
                            console.debug('Token is still valid');
                        }
                    })
                    .catch(() => {
                        console.warn('Failed to refresh the token, or the session has expired');
                        this._keyClock.login();
                    });
            };

            this._keyClock.onAuthLogout = () => {
                this.pendingAutorisationServer = false;
            };

            this._keyClock
                .init({
                    onLoad: 'check-sso'
                })
                .then((auth) => {
                    if (auth) {
                        this._isLoading = false;
                        resolve(false);
                    } else {
                        this._keyClock.login();
                    }
                });
        });
    }

    get keyClock() {
        return this._keyClock;
    }

    get InactivityTimout() {
        return this._InactivityTimout || 0;
    }

    set InactivityTimout(time: number) {
        this._InactivityTimout = time;
    }

    set keyClock(k: Keycloak) {
        this._keyClock = k;
    }

    private _isLoading = true;
    get isLoading(): boolean {
        return this._isLoading;
    }

    get authenticated() {
        return this._keyClock?.authenticated != null ? this._keyClock.authenticated : false;
    }

    get user() {
        return this._user;
    }

    get token() {
        return this._keyClock?.token;
    }

    get accessRoles() {
        return this._user?.role;
    }

    get pendingAuthServer() {
        return this.pendingAutorisationServer;
    }

    setNotAut() {
        this.pendingAutorisationServer = false;
    }

    setUser() {
        //console.debug('setUser');
        let _roles: string[] | undefined = this._keyClock?.tokenParsed?.resource_access?.ixybertraining?.roles;
        let user: IUser = {
            id: this._keyClock?.tokenParsed?.preferred_username,
            middleName: this._keyClock?.tokenParsed?.middle_name || '',
            givenName: this._keyClock?.tokenParsed?.given_name || '',
            familyName: this._keyClock?.tokenParsed?.family_name || '',
            email: this._keyClock?.tokenParsed?.email || '',
            role: _roles != undefined ? _roles : []
        };
        this.pendingAutorisationServer = false;
        this._user = user;
    }
}

export default AuthStore;
